import { connect } from "react-redux";
import get from "lodash/get";

import {
  getLogisticRoutes as onGetLogisticRoutes,
  getLogisticRoute as onGetLogisticRoute,
  createLogisticRoute as onCreateLogisticRoute,
  deleteLogisticRoute as onDeleteLogisticRoute,
  selectLogisticRoute as onSelectLogisticRoute,
  updateLogisticRoute as onUpdateLogisticRoute,
  addControlPointRoute as onAddControlPointRoute,
  deleteControlPointRoute as onDeleteControlPointRoute,
  getLogisticRouteGeoJson as onGetLogisticRouteGeoJson,
  setNumberControlPointRoute as onSetNumberControlPointRoute,
} from "./../../actions/logisticRoutesActions";

const mapStateToProps = (state) => ({
  logisticRoutesDataState: state.logisticRoutes.logisticRoutesDataState,
  logisticRouteDataState: state.logisticRoutes.logisticRouteDataState,
  logisticRouteGeoJsonDataState: state.logisticRoutes.logisticRouteGeoJsonDataState,
  logisticCreateRoutesDataState: state.logisticRoutes.logisticCreateRoutesDataState,
  logisticDeleteRoutesDataState: state.logisticRoutes.logisticDeleteRoutesDataState,
  logisticUpdateRoutesDataState: state.logisticRoutes.logisticUpdateRoutesDataState,
  logisticAddControlPointRouteDataState: state.logisticRoutes.logisticAddControlPointRouteDataState,
  logisticDeleteControlPointRouteDataState: state.logisticRoutes.logisticDeleteControlPointRouteDataState,
  logisticSetNumberControlPointRouteDataState: state.logisticRoutes.logisticSetNumberControlPointRouteDataState,
  logisticRoutes: get(state, ["logisticRoutes", "logisticRoutes"], []),
  logisticSelectedRoute: get(state, ["logisticRoutes", "logisticSelectedRoute"], null),
});

const mapDispatchToProps = {
  onGetLogisticRoutes,
  onGetLogisticRoute,
  onCreateLogisticRoute,
  onDeleteLogisticRoute,
  onSelectLogisticRoute,
  onUpdateLogisticRoute,
  onAddControlPointRoute,
  onDeleteControlPointRoute,
  onGetLogisticRouteGeoJson,
  onSetNumberControlPointRoute,
};

const withLogisticRoutes = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withLogisticRoutes };
